import React, {useState, useEffect} from 'react';
import Grid from '@material-ui/core/Grid';
import Header from './Header'
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import useStore from './store' 
import Typography from '@material-ui/core/Typography';
import _ from 'lodash'
import {CustomSelect, CustomInput, CustomDatePicker} from './Component'
import Button from '@material-ui/core/Button';
import Swal from 'sweetalert2';
import {doPost} from './AjaxRequests'
import { useHistory, Link} from "react-router-dom";
import queryString, { parse } from "query-string"
import Box from '@material-ui/core/Box';
import Countdown from 'react-countdown';
import zeroFill from 'zero-fill'
import RefreshIcon from '@material-ui/icons/Refresh';

const useStyles = makeStyles(theme => ({    
    paper:{
        padding: theme.spacing(3),
        backgroundColor: theme.palette.paper.white,        
    },  
    subTitle:{
        color: theme.palette.text.white,
        fontSize:"18px" 
    },
    btn__wrapper:{
        width:"100%",
        display:"flex",
        alignContent:"center",
        justifyContent:"center",
        padding:theme.spacing(2,0)
    },
    qrcode:{
        width:"55%",
        margin: "8px auto",
        display: "block"
    },
    print_container:{
        
    },
    print_content:{

    },
    result_explanation:{
        lineHeight:'2'
    },
    countDown:{
        width:"100%",
        textAlign:"center",
        fontSize:"16px",
        paddingBottom:theme.spacing(2)
    },
    message:{
        // color:"red",
        fontSize:"28px",
        fontWeight: 700
    },
    message_error:{
         color:"red",
         fontSize:"28px",
        fontWeight: 700
    }
}));

const renderer = ({minutes, seconds }) => {    
    return <span>{zeroFill(2, minutes)}:{zeroFill(2,seconds)}</span>;    
};


function Result(props) {
    const history = useHistory();
    const classes = useStyles(props);     
    const [info, setInfo] = useState(null)
    const [qrcode, setQrcode] = useState(null)
    const [codeActive, setCodeActive] = useState(true)
    const [isQuery, setIsQuery] = useState(false)

    useEffect(()=>{
        const parsed = queryString.parse(props.location.search);       

        if(parsed.access_key){
            const payload = {
                "api": "GetDoorAccessKey",
                "access_key":parsed.access_key
            }
            doPost('https://www.kfsyscc.org/normal_api/service', payload)
            .then((data)=>{
                if(data.status){                       
                    return data                
                }                
            })
            .then((data)=>{
                const payload_1 = {
                    "api": "QRGen",
                    "access_key":data.data.access_key
                }
                return doPost('https://www.kfsyscc.org/normal_api/service', payload_1)
                .then((data_1)=>{
                    if(data_1.status){
                        setInfo({...data.data, ...data_1.data})
                        return data_1.data.qrcode
                    }                
                })                
            })
            .then((qrcode)=>{
                return fetch(`https://www.kfsyscc.org/kqrcode/api/qview?data=${qrcode}&size=6&correct=H`)               
                .then(response => response.blob())
                .then(images => {                       
                    let img = URL.createObjectURL(images)
                    setQrcode(img)                   
                })
            })
        }   

        if(parsed.result_type && parsed.result_type==="query"){           
            setIsQuery(true)
        }
        
    },[])

    const handlePrint=()=>{
        window.print();
    }

    const handleEnd=()=>{
        setCodeActive(false)
    }

    if(info ==null){
        return (<Grid container spacing={3}>
                <Grid item xs={12}>
                    <Header/>
                </Grid>
                <Grid item xs={12}>
                <Typography 
                    variant="h6"
                    className={classes.subTitle}
                >
                    LOADING...
                </Typography>
        </Grid>  
            </Grid>
             )
    }

    return (        
      <Grid container spacing={3}>
        <Grid item xs={12}>
            <Header/>
        </Grid> 
        <Grid item xs={12} style={{display:"flex" , alignItems:"center", justifyContent:"space-between"}}>
            <Typography 
                variant="h6"
                className={classes.subTitle}
            >
                申請結果                
            </Typography>
            {isQuery?<Button variant="contained" startIcon={<RefreshIcon />} onClick={()=>{window.location.reload()}}>重新整理</Button>:null}
        </Grid>  
        <Grid item xs={12}>
            <Paper
                square                   
                className={`${classes.paper} ${classes.print_container}`}
                elevation={3}
            >
                <Grid container spacing={2}  className={classes.print_content}>
                    <Grid item xs={12}>                       
                        <Typography variant="body2" align="center" className={info.pass === "Y"?classes.message:classes.message_error}>
                            {info.message}
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>                       
                        <img src={qrcode} className={classes.qrcode}/>
                    </Grid>

                    {/* <Grid item xs={12}>     
                        <div className={classes.countDown}>
                            {codeActive?
                            <Countdown 
                                date={Date.now() + 300000}
                                renderer={renderer}
                                zeroPadTime={2}
                                onComplete={handleEnd}                                
                            />:'此驗證碼已失效，請點選"重新整理"以重新獲得驗證碼'}
                        </div>                       
                    </Grid> */}
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            申請人姓名：{info.apply_user_name}
                        </Typography>
                    </Grid>
                
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            申請人身分證字號：{info.apply_user_idno}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            病人身分證字號：{info.idno}
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            申請通關原因：{info.reason_name}
                        </Typography>
                    </Grid>


                    <Grid item xs={12}>
                        <Typography variant="body2">
                            申請通關日期：{info.reg_date?(info.reg_date.slice(0,4)+"-"+info.reg_date.slice(4,6)+"-"+info.reg_date.slice(6,8)):""}
                        </Typography>
                    </Grid>
               
                    <Grid item xs={12}>
                        <Typography variant="body2">
                            本通行證有效期(開始)：{info.start_datetime }
                        </Typography>                        
                    </Grid>
                
                    <Grid item xs={12}>                       
                        <Typography variant="body2">
                            本通行證有效期(結束)：{info.close_datetime }
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>                       
                        <Typography variant="body2">
                            申請結果：{info.pass==='Y'?"成功":"失敗"}
                        </Typography>
                    </Grid>
                    
                    <Grid item xs={12}>                       
                        <Typography variant="body2" className={classes.result_explanation}>
                            注意事項：<br/>　　{info.tocc_message}
                        </Typography>
                    </Grid>

                    
                    <Grid item xs={12}>    
                        {codeActive? null:                  
                        <Box className={classes.btn__wrapper}>
                            <Button variant="contained" color="primary" onClick={()=>{window.location.reload()}}>
                                重新整理
                            </Button>
                        </Box> }
                    </Grid>

                    <Grid item xs={12}>                 
                        <Box className={classes.btn__wrapper}>
                            <Button variant="contained" color="primary" onClick={handlePrint}>
                                儲存成PDF
                            </Button>
                        </Box>                           
                    </Grid>
        
                </Grid>
            </Paper>   
        </Grid>    
        <Grid item xs={12}>
            {isQuery?<Box className={classes.btn__wrapper}>                
                <Button variant="contained" color="primary" onClick={()=>{history.goBack()}}>
                    上一頁
                </Button>                  
            </Box>
           :  
             <Box className={classes.btn__wrapper}>
                <Link to="/" style={{textDecoration:"none", margin:"0 20px"}}>
                    <Button variant="contained" color="primary">
                        回首頁
                    </Button> 
                </Link> 
            </Box>}                                          
        </Grid>               
                  
      </Grid> 
    );
}


export default Result